import { render } from "./StoryPoint.vue?vue&type=template&id=2e73924b&scoped=true"
import script from "./StoryPoint.vue?vue&type=script&lang=js"
export * from "./StoryPoint.vue?vue&type=script&lang=js"

import "./StoryPoint.vue?vue&type=style&index=0&id=2e73924b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e73924b"
/* hot reload */
if (module.hot) {
  script.__hmrId = "2e73924b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e73924b', script)) {
    api.reload('2e73924b', script)
  }
  
  module.hot.accept("./StoryPoint.vue?vue&type=template&id=2e73924b&scoped=true", () => {
    api.rerender('2e73924b', render)
  })

}

script.__file = "src/components/StoryPoint.vue"

export default script